export var ChatStatus;
(function (ChatStatus) {
    ChatStatus[ChatStatus["WAITING"] = 0] = "WAITING";
    ChatStatus[ChatStatus["ACTIVE"] = 1] = "ACTIVE";
    ChatStatus[ChatStatus["COMPLETED"] = 2] = "COMPLETED";
    ChatStatus[ChatStatus["TRANSFERRED_WAITING"] = 22] = "TRANSFERRED_WAITING";
    ChatStatus[ChatStatus["TRANSFERRED_COMPLETED"] = 23] = "TRANSFERRED_COMPLETED";
    ChatStatus[ChatStatus["PENDING_OUTBOUND"] = 3] = "PENDING_OUTBOUND";
})(ChatStatus || (ChatStatus = {}));
;
//# sourceMappingURL=chat-status.enum.js.map